import { render, staticRenderFns } from "./MXImage.vue?vue&type=template&id=fc5015de&scoped=true"
import script from "./MXImage.vue?vue&type=script&lang=js"
export * from "./MXImage.vue?vue&type=script&lang=js"
import "./MXImage.vue?vue&type=style&index=0&id=fc5015de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5015de",
  null
  
)

export default component.exports